export default "__VITE_ASSET__xcDT8pAb__"